import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Checkbox from '../../Checkbox/Checkbox'
import SignatureImage from '../elements/SignatureImage'

class SaleConditions extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      editable: false
    }
    this.toggleEdit = this.toggleEdit.bind(this)
    this.onChange = this.onChange.bind(this)
    this.input = React.createRef()
  }
  onChange () {
    this.props.onChange('saleConditions', this.input.current.value)
  }
  componentDidUpdate (prevProps) {
    // switching to Vendor Assessed closes the Sale Terms again
    if (this.props.locked && !prevProps.locked && this.state.editable) {
      this.setState({ editable: false })
    }
  }
  toggleEdit () {
    this.setState((prevState) => {
      return { editable: !prevState.editable }
    })
  }
  render () {
    const { saleConditions, disabled, agentSignature, locked } = this.props
    // a Vendor Assessed Lot is sold on the standard terms, only an Agent
    // Assessed one can change them
    const editable = this.state.editable && !locked
    return (
      <div className={`input-section ${disabled ? 'disabled' : ''}`}>
        <div className='section-heading'>
          <div className='heading-title'>Special Conditions of Sale</div>
        </div>
        <div className='section-body'>
          <div className='form-row'>
            <div className='row-title'>
              <p
                className='row-text'>Change Sale Terms</p>
            </div>
            <div className='row-content'>
              <Checkbox
                type='green'
                value={editable}
                fgDisabled={locked}
                onToggle={this.toggleEdit} />
            </div>
          </div>
          <div className='form-row form-row-long'>
            <div className='row-title'>
              <p
                className='row-text'>Sale Terms:</p>
            </div>
            <div className='row-content'>
              <textarea
                ref={this.input}
                className={`textarea ${!editable ? 'disabled' : ''}`}
                value={saleConditions}
                disabled={!editable}
                maxLength={150}
                onChange={this.onChange}
              />
            </div>
          </div>
          {agentSignature && agentSignature.url && <div className='form-row form-row-long'>
            <div className='row-title'>
              <p
                className='row-text'>Agent Signature Capture</p>
            </div>
            <div className='row-content'>
              <SignatureImage src={agentSignature.url} />
            </div>
          </div>}
        </div>
      </div>
    )
  }
}

SaleConditions.propTypes = {
  saleConditions: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  locked: PropTypes.bool
}

SaleConditions.defaultProps = {
  disabled: false,
  locked: false
}

export default SaleConditions
